import React, { useState, useEffect, useContext } from "react";
import { VideoPlayerContext } from './VideoPlayerContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons'
import { faPauseCircle } from '@fortawesome/free-solid-svg-icons'

let globalAudio = null;

export const getGlobalAudio = () => globalAudio;

const useAudio = url => {
  const [audio] = useState(() => {
    const newAudio = new Audio(url);
    newAudio.preload = "none";
    globalAudio = newAudio;
    return newAudio;
  });
  const [playing, setPlaying] = useState(false);

  const toggle = () => setPlaying(!playing);

  useEffect(() => {
      playing ? audio.play() : audio.pause();
    },
    [playing]
  );

  useEffect(() => {
    audio.addEventListener('ended', () => setPlaying(false));
    audio.addEventListener('pause', () => setPlaying(false));
    audio.addEventListener('play', () => setPlaying(true));
    return () => {
      audio.removeEventListener('ended', () => setPlaying(false));
      audio.removeEventListener('pause', () => setPlaying(false));
      audio.removeEventListener('play', () => setPlaying(true));
    };
  }, []);

  return [playing, toggle, audio];
};

const Player = ({ url }) => {
  const { setIsPlaying, playerRef } = useContext(VideoPlayerContext);
  const [playing, toggle, audio] = useAudio(url);

  const handleToggle = () => {
    if (!playing && playerRef.current) {
      playerRef.current.pause();
      setIsPlaying(false);
    }
    toggle();
  };
  const [volume, setVolume] = useState(1);

  useEffect(() => {
    if (audio) {
      audio.volume = volume;
    }
    if (playerRef.current) {
      playerRef.current.volume(volume);
    }
  }, [volume, audio]);

  if (!playing) {
      var playingStatus = <FontAwesomeIcon size='3x' onClick={handleToggle} icon={faPlayCircle} color="#FF2C5E" />
  } else {
    var playingStatus = <FontAwesomeIcon size='3x' onClick={handleToggle} icon={faPauseCircle} color="#FF2C5E" />
  }

  return (
    <div>
     {playingStatus}
    </div>
  );
};

export default Player;